import { Scene, ShaderMaterial } from '@babylonjs/core';

import './shader/TourDanjiSkyLightShader';

export class TourdanjiSkyMaterialLight extends ShaderMaterial {
  private _horizonHeight: number = 0.5;

  public set horizonHeight(value: number) {
    this._horizonHeight = value;
    this.setFloat('horizonHeight', value);
  }

  public get horizonHeight() {
    return this._horizonHeight;
  }
  
  constructor(name: string, scene: Scene) {
    super(
      name,
      scene,
      {
        vertex: 'tourdanjiSkyLight',
        fragment: 'tourdanjiSkyLight',
      },
      {
        attributes: ['position', 'normal', 'uv'],
        uniforms: ['world', 'worldView', 'worldViewProjection', 'view', 'projection', 'horizonHeight'],
      }
    );
    
    this.backFaceCulling = false;
    
    // 기본값 설정
    this.horizonHeight = 0.5;
  }

  public override dispose() {
    super.dispose();
  }
}
